export const safeJoin = (
  feilds,
  { placeholder = "", separator = " " } = {}
) => {
  return isArray(feilds)
    ? feilds
        .map(v => dangerTransfer(v, placeholder))
        .filter(v => v !== "")
        .join(separator)
    : dangerTransfer(feilds, placeholder);
};

export const safeJoinWithPlaceholder = (
  feilds,
  { separator = " ", placeholder = "-" } = {}
) =>
  safeJoin(feilds, {
    placeholder,
    separator
  });

export const valueOf = v => new String(v).valueOf();

export const isNull = v => v === null;

export const isUndefined = v => v === undefined;

export const isNaN = v => valueOf(v) === "NaN";

export const isEmptyString = v => v === "" || v === " ";

export const dangerTransfer = (v, placeholder = "") => {
  return isNull(v) || isUndefined(v) || isNaN(v) || isEmptyString(v)
    ? placeholder
    : v;
};

export const isArray = v => v instanceof Array;

export default {
  install(Vue) {
    Vue.prototype.$j = safeJoin;
    Vue.prototype.$jp = safeJoinWithPlaceholder;
  }
};
